module.exports = __webpack_public_path__ + "img/picture2.943cd4e1.webp";